<template>
  <!-- 年度分析报告表格 -->

  <div class="page">
    <div class="pageTable">
      <div class="hearder_title">
        <p class="headline">{{getZykInformation.zykName}}专业教学资源库基本报告（{{getZykInformation.zykNum}}）</p>
        <p class="distinguish">
          <!-- <span v-if="getZykInformation.status == 1">状态：申报中</span>
          <span v-else-if="getZykInformation.status == 2">状态：已立项</span>
          <span v-else>状态：已验收</span>
          <span>主持单位：{{getZykInformation.hostUnit}}</span>
          <span>联合主持单位：<span v-for="(item,index) in getZykInformation.coHostUnit" :key="index">{{index == getZykInformation.coHostUnit.length-1 && item || (item + '，') }}</span></span> -->
          <span>主持单位：{{getZykInformation.allHostUnit}}</span>
          <span>数据截止时间：{{getZykInformation.endTime}}</span>
        </p>
        <div class="lineBox">
          <p></p>
          <p></p>
        </div>
      </div>

      <table border="1" cellspacing="0" cellpadding="0" class="tables" style="border: none;">
        <tr>
          <th class="borderBaise " style="width: 9%;">一级指标</th>
          <th class="borderBaise borderLeft" style="width: 24%;">二级指标</th>
          <th class="borderBaise borderLeft borderRight" style="width: 46;">三级指标</th>
          <th class="borderBaise" colspan="6" style="width: 21%;">统计值</th>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderBottom" rowspan="4">用户</td>
          <td class="borderBaise borderTop borderLeft" rowspan="4">用户总数</td>
          <td class="borderBaise borderTop ">注册教师用户数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">注册学生用户数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">建设院校已实名教师数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">建设院校近三年注册并已实名学生数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="1">资源</td>
          <td class="borderBaise borderTop borderLeft" rowspan="1">资源总数</td>
          <td class="borderBaise borderTop">总量</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="2">课程</td>
          <td class="borderBaise borderTop borderLeft">标准化课程</td>
          <td class="borderBaise borderTop">总量</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">标准化课程课程开课期数</td>
          <td class="borderBaise borderTop">总量</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="13">用户更新</td>
          <td class="borderBaise borderTop borderLeft" rowspan="3">历年新增用户数</td>
          <td class="borderBaise borderTop">2020年新增用户</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2021年新增用户</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2022年新增用户</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="3">同比上一年用户新增率</td>
          <td class="borderBaise borderTop">2020年比2019年新增率</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2021年比2020年新增率</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2022年比2021年新增率</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="1">删除用户数</td>
          <td class="borderBaise borderTop">删除用户总数</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="3">已实名用户活跃数</td>
          <td class="borderBaise borderTop">2020年已实名用户活跃数</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2021年已实名用户活跃数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2022年已实名用户活跃数</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="3">已实名用户活跃情况</td>
          <td class="borderBaise borderTop">2020年已实名用户活跃占比</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2021年已实名用户活跃占比</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2022年已实名用户活跃占比</td>
          <td class="borderBaise borderTop  " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop" rowspan="12">资源更新</td>
          <td class="borderBaise borderTop borderLeft" rowspan="3">历年新增资源数</td>
          <td class="borderBaise borderTop">2020年新增资源</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2021年新增资源</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop">2022年新增资源</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="1">删除资源数</td>
          <td class="borderBaise borderTop">删除资源总数</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="1">修改资源数</td>
          <td class="borderBaise borderTop">修改资源总数</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft" rowspan="3">同比上一年资源更新率</td>
          <td class="borderBaise borderTop">2020年比2019年更新率</td>
          <td class="borderBaise borderTop" colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop ">2021年比2020年更新率</td>
          <td class="borderBaise borderTop " colspan="2"></td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderBottoms">2022年比2021年更新率</td>
          <td class="borderBaise borderTop borderBottoms" colspan="2"></td>
        </tr>

        <!-- <tr>
          <td colspan="8" style="border: none;"></td>
        </tr>

        <tr v-for="(item,index) in distribution" :key="index+0.1">
          <td class="borderBaise" v-show="index == 0" rowspan="14">应用情况</td>
          <td class="borderBaise borderLeft" v-show="index == 0" :rowspan="distribution.length">用户访问行为分布</td>
          <td v-if="index == distribution.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != distribution.length-1 && index != 0">{{item.action}}</td>
          <td v-if="index == 0" class="borderBaise borderBottom borderLeft borderRight">{{item.action}}</td>
          <td v-if="index == distribution.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != distribution.length-1 && index != 0" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
          <td v-if="index == 0" class="borderBaise borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in forum" :key="index+0.2">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="forum.length">论坛情况</td>
          <td class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td class="borderBaise borderTop" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in conditions" :key="index+0.3">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="conditions.length">作业情况</td>
          <td v-if="index == conditions.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != conditions.length-1">{{item.action}}</td>
          <td v-if="index == conditions.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != conditions.length-1" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(item,index) in situation" :key="index+0.4">
          <td class="borderBaise borderTop borderLeft" v-show="index == 0" :rowspan="situation.length">考试情况</td>
          <td v-if="index == situation.length-1" class="borderBaise borderTop borderLeft borderRight">{{item.action}}</td>
          <td v-if="index != situation.length-1">{{item.action}}</td>
          <td v-if="index == situation.length-1" class="borderBaise borderTop" colspan="2">{{item.num}}</td>
          <td v-if="index != situation.length-1" class="borderBaise borderTop borderBottom" colspan="2">{{item.num}}</td>
        </tr>

        <tr v-for="(itemobj6,indexObj6) in userUpdateobj.usersOverTheYears" :key="indexObj6+0.5">
          <td class="borderBaise borderTop" :rowspan='userUpdateobj.usersOverTheYears.length + 1' v-if="itemobj6.oneLevel">{{itemobj6.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='userUpdateobj.usersOverTheYears.length' v-if="itemobj6.secondLevel">{{itemobj6.secondLevel}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1">{{itemobj6.yearUpdate}}</td>
          <td v-if="indexObj6 == userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj6.num}}</td>
          <td v-if="indexObj6 != userUpdateobj.usersOverTheYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj6.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除用户数</td>
          <td class="borderBaise borderTop borderLeft borderRight">删除用户总数</td>
          <td colspan="6" class="borderBaise borderTop">{{userUpdateobj.usersDeleted}}</td>
        </tr>

        <tr v-for="(itemobj7,indexObj7) in resourceUpdate.resourcesYears" :key="indexObj7+0.6">
          <td class="borderBaise borderTop" :rowspan='resourceUpdate.resourcesYears.length + 1 + resourceUpdate.renewalRate.length+1' v-if="itemobj7.oneLevel">{{itemobj7.oneLevel}}</td>
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.resourcesYears.length' v-if="itemobj7.secondLevel">{{itemobj7.secondLevel}}</td>
          <td v-if="indexObj7 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj7.yearUpdate}}</td>
          <td v-if="indexObj7 != resourceUpdate.resourcesYears.length-1">{{itemobj7.yearUpdate}}</td>
          <td v-if="indexObj7 == resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop" colspan="6">{{itemobj7.num}}</td>
          <td v-if="indexObj7 != resourceUpdate.resourcesYears.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj7.num}}</td>
        </tr>

        <tr v-for="(itemobj8,indexObj8) in resourceUpdate.renewalRate" :key="indexObj8+0.6">
          <td class="borderBaise borderTop borderLeft" :rowspan='resourceUpdate.renewalRate.length' v-if="itemobj8.secondLevel">{{itemobj8.secondLevel}}</td>
          <td v-if="indexObj8 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderLeft borderRight">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 != resourceUpdate.renewalRate.length-1">{{itemobj8.yearUpdate}}</td>
          <td v-if="indexObj8 == resourceUpdate.renewalRate.length-1" class="borderBaise borderTop" colspan="6">{{itemobj8.num}}</td>
          <td v-if="indexObj8 != resourceUpdate.renewalRate.length-1" class="borderBaise borderTop borderBottom" colspan="6">{{itemobj8.num}}</td>
        </tr>

        <tr>
          <td class="borderBaise borderTop borderLeft">删除资源数</td>
          <td class="borderBaise borderTop borderLeft borderRight">删除资源总数</td>
          <td class="borderBaise borderTop" colspan="6">{{resourcesDeleted}}</td>
        </tr> -->
      </table>
    </div>
    <el-backtop :bottom="80" class="backtops"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getBasicReportUserVoObj: {}, // 一级指标用户
      getStatResourceDataEntityobj: {}, // 素材资源
      recordsnumber: 0, // 无访问记录总数
      citednumber: 0, // 资源被课程引用的占比
      materialsNum: 0, // 素材资源使用总次数
      visitsNum: 0, // 访问总量
      situationNum: 0, // 论坛情况
      conditionNum: 0, // 作业情况
      examinationNum: 0, // 考试情况
      getResourceApplicationVoobj: { // 1-素材资源应用情况，2-用户访问行为分布,3-论坛情况,4-作业情况,5-考试情况
        obj1: [],
        obj2: [],
        obj3: [],
        obj4: [],
        obj5: [],
      },
      getCourseCountVoObj: {}, // 课程

      getZykInformation: { // 头部基本信息
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: '',
      },
      userTotal: { // 用户总数
        registerUserCount: '',
        presideSchoolRealnameTeacherCount: '',
        presideSchoolRealnameTeacherCountPercentage: '',
        realnameTeacherCount: '',
        realnameTeacherDaySum: '',
        noActiveRealnameTeacherCount: '',
        noActiveRealnameTeacherPercentage: '',
        realnameStudentCount: '',
        realnameStudentDaySum: '',
        noActiveRealnameStudentCount: '',
      },
      material: { // 获取素材资源,素材资源使用总次数,素材资源应用情况,平均每个资源使用次数
        resourceCount: '',
        textVo: {
          percentage: '',
          sumValue: '',
        },
        textPPTVo: {
          percentage: '',
          sumValue: '',
        },
        animationVo: {
          percentage: '',
          sumValue: '',
        },
        virtualVo: {
          percentage: '',
          sumValue: '',
        },
        audioVo: {
          percentage: '',
          sumValue: '',
        },
        videoVo: {
          percentage: '',
          sumValue: '',
        },
        smallCourseVo: {
          percentage: '',
          sumValue: '',
        },
        otherVo: {
          percentage: '',
          sumValue: '',
        },
        originVo: {
          percentage: '',
          sumValue: '',
        },
        noActiveResourceCountVo: {
          percentage: '',
          sumValue: '',
        },
        courseResourceVo: {
          percentage: '',
          sumValue: '',
        },
        questionVo: {
          percentage: '',
          sumValue: '',
        },
        resourceLogCount: '',
        viewResourceVo: {
          percentage: '',
          sumValue: '',
        },
        commentResourceVo: {
          percentage: '',
          sumValue: '',
        },
        downloadResourceVo: {
          percentage: '',
          sumValue: '',
        },
        collectionResourceVo: {
          percentage: '',
          sumValue: '',
        },
        otherResourceVo: {
          percentage: '',
          sumValue: '',
        },
        averageResourceLogCount: '',
      },
      courses: { // 标准化课程,无访问标准化课程数,标准化课程的选课用户总数,标准化课程课程开课期数
        courseBzNum: '',
        jsCourseBzNum: '',
        courseBzUserNum: '',
        courseTime: '',
      },

      distribution: [], // 用户访问行为分布
      forum: [], // 论坛情况
      conditions: [], // 作业情况
      situation: [], // 考试情况

      userUpdateobj: { // 用户更新（历年新增用户数，删除用户数）
        usersOverTheYears: [],
        usersDeleted: 0,
      },

      resourceUpdate: { // 资源更新（同比上一年资源更新率,历年新增资源数）
        renewalRate: [],
        resourcesYears: [],
      },
      resourcesDeleted: 0, // 删除资源数
    };
  },
  created() {
    this.getZykInformationVo();
    this.getBasicReportUserVo();
    this.getBasicReportResourceVo();
    this.getCourseCountVo();
    this.distributionVo();
    this.forumVo();
    this.conditionsVo();
    this.situationVo();

    this.usersOverTheYearss();
    this.usersDeleteds();
    this.resourcesYearss();
    this.renewalRates();
    this.resourcesDeleteds();
  },
  methods: {
    // 获取报告基本信息
    getZykInformationVo() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.getZykInformation = res.data;
          this.getZykInformation.allHostUnit = res.data.allHostUnit.replaceAll(',', '，');
        }
      });
    },

    // 获取用户总数
    getBasicReportUserVo() {
      this.$axios.post(this.$apiurls.report_year_getBasicReportUserVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userTotal = res.data;
        }
      });
    },

    // 获取素材资源,素材资源使用总次数,素材资源应用情况,平均每个资源使用次数
    getBasicReportResourceVo() {
      this.$axios.post(this.$apiurls.report_year_getBasicReportResourceVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.material = res.data;
        }
      });
    },

    // 标准化课程,无访问标准化课程数,标准化课程的选课用户总数,标准化课程课程开课期数
    getCourseCountVo() {
      this.$axios.post(this.$apiurls.report_year_getCourseCountVo, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.courses = res.data;
        }
      });
    },

    // 用户访问行为分布
    distributionVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.distribution = res.data;
        }
      });
    },

    // 论坛情况
    forumVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 3, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.forum = res.data;
        }
      });
    },

    // 作业情况
    conditionsVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 4, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.conditions = res.data;
        }
      });
    },
    // 考试情况
    situationVo() {
      this.$axios.post(this.$apiurls.report_year_getResourceApplicationVo, 5, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.situation = res.data;
        }
      });
    },

    // 获取用户更新历年新增用户数
    usersOverTheYearss() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '用户更新';
              res.data[i].secondLevel = '历年新增用户数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }
          this.userUpdateobj.usersOverTheYears = res.data;
        }
      });
    },

    // 获取用户更新删除用户数
    usersDeleteds() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 1, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.userUpdateobj.usersDeleted = res.data;
        }
      });
    },

    // 获取资源更新历年新增资源数
    resourcesYearss() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 3, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].oneLevel = '资源更新';
              res.data[i].secondLevel = '历年新增资源数';
            } else {
              res.data[i].oneLevel = '';
              res.data[i].secondLevel = '';
            }
          }

          this.resourceUpdate.resourcesYears = res.data;
        }
      });
    },

    // 获取资源更新同比上一年资源更新率
    renewalRates() {
      this.$axios.post(this.$apiurls.report_yaer_getResourceOrUserUpdateVo, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].num) {
              res.data[i].num = 0;
            }
            if (i == 0) {
              res.data[i].secondLevel = '同比上一年资源更新率';
            } else {
              res.data[i].secondLevel = '';
            }
          }
          this.resourceUpdate.renewalRate = res.data;
        }
      });
    },

    // 获取资源更新删除资源数
    resourcesDeleteds() {
      this.$axios.post(this.$apiurls.report_yaer_getDeleteNum, 2, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.resourcesDeleted = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  background: #fff;
}
.pageTable {
  width: 75%;
  height: auto;
  margin: 50px auto 50px;
}
.hearder_title {
  text-align: center;
  font-weight: 700;
  font-size: 15px;
}

.headline {
  font-size: 26px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 41px;
}

.distinguish {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  color: #707f9d;
  font-size: 17px;
  font-weight: 400;
}

.lineBox {
  margin-bottom: 20px;
}
.lineBox p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  padding: 0px;
  margin: 0px;
  margin-top: 8px;
}
.lineBox p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.tables {
  width: 100%;
  text-align: center;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr {
  height: 47px;
  color: #566178;
  border-color: rgba(112, 127, 157, 0.4);
}

.tables tr:first-child {
  background: rgba(204, 204, 204, 0.403);
}

.el-backtop.backtops {
  background: #66adff;
}

.el-backtop,
.el-calendar-table td.is-today {
  color: #fff;
}

.borderBaise {
  border: 2px solid #b6b6b6;
}

.borderTop {
  border-top-width: 1px;
}

.borderBottom {
  border-bottom-width: 1px;
}

.borderLeft {
  border-left-width: 1px;
}

.borderRight {
  border-right-width: 1px;
}
</style>
